import { createSelector } from 'reselect';

import { idX } from '../helpers';

export const isBottom = state => state.helper.isBottom;

export const isBottomSelector = createSelector(isBottom, idX);
